<template>
  <div class="download-container">
    <iframe id="schema" style="display: none;"></iframe>

    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="nav-left">
        <img alt="陌撩漂流瓶" class="nav-logo" src="https://img.moliaos.com/v/logo.png"/>
        <span class="nav-title">陌撩漂流瓶</span>
      </div>
      <div class="nav-right">
        <el-button class="main-download-btn" @click="jumpAppStore">
          {{ '立即下载' }}
        </el-button>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">

      <!-- 福利专区 - 突出返利金币 -->
      <div class="hero-section">
        <div class="hero-text">
          <h1 class="hero-title gradient-text">注册即享<br/>专属福利</h1>
          <div class="section-badge gold-badge">🎁 新人专享</div>
          <ul class="benefit-list">
            <li class="benefit-item gold-item">
              <span class="benefit-icon">👑</span>
              <div class="benefit-content">
                <strong>新人见面礼</strong>
                <p>注册送豆子奖励</p>
              </div>
            </li>
                        <li class="benefit-item gold-item">
              <span class="benefit-icon">📅</span>
              <div class="benefit-content">
                <strong>活动任务</strong>
                <p>完成活动任务赢豆子</p>
              </div>
            </li>
            <li class="benefit-item gold-item">
              <span class="benefit-icon">🔥</span>
              <div class="benefit-content">
                <strong>限时福利</strong>
                <p>提现返20%奖励</p>
              </div>
            </li>
            <li class="benefit-item gold-item">
              <span class="benefit-icon">🎁</span>
              <div class="benefit-content">
                <strong>日常签到</strong>
                <p>每日打卡领积分</p>
              </div>
            </li>

          </ul>
        </div>
        <div class="hero-image-wrapper compact">
          <el-image :src="require('@/assets/img/main/3.png')" class="hero-image compact" lazy></el-image>
        </div>
      </div>

      <!-- 热度推广指南 -->
      <div class="hero-section reverse-layout">
        <div class="hero-text">
          <h1 class="hero-title gradient-text">交友新方式<br/>遇见有缘人</h1>
          <div class="section-badge hot-badge">🔥 热门推荐</div>
          <p class="hero-subtitle">漂流瓶交友，温暖每一份相遇</p>
          <div class="promo-guide">
            <div class="guide-item">
              <span class="guide-num">1</span>
              <span class="guide-text">扔出漂流瓶，写下心情</span>
            </div>
            <div class="guide-item">
              <span class="guide-num">2</span>
              <span class="guide-text">随机匹配，邂逅缘分</span>
            </div>
            <div class="guide-item">
              <span class="guide-num">3</span>
              <span class="guide-text">畅聊互动，收获友谊</span>
            </div>
          </div>
        </div>
        <div class="hero-image-wrapper compact">
          <el-image :src="require('@/assets/img/main/1.png')" class="hero-image compact" lazy></el-image>
        </div>
      </div>

      <!-- 真实用户保障 -->
      <div class="hero-section">
        <div class="hero-text">
          <h1 class="hero-title">安心交友<br/>真实可靠</h1>
          <p class="hero-subtitle">多重认证守护你的社交安全</p>
          <div class="trust-indicators">
            <div class="trust-item">
              <span class="trust-icon">✓</span>
              <span class="trust-label">实名认证</span>
            </div>
            <div class="trust-item">
              <span class="trust-icon">✓</span>
              <span class="trust-label">隐私保护</span>
            </div>
            <div class="trust-item">
              <span class="trust-icon">✓</span>
              <span class="trust-label">客服支持</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 应用商店下载区域 -->
      <div class="stores-section">
        <h2 class="stores-title">各大应用商店均可下载</h2>
        <div class="stores-grid">
          <div class="store-item">
            <div class="store-icon huawei">
              <span class="store-text">华为</span>
            </div>
            <span class="store-name">华为应用市场</span>
          </div>
          <div class="store-item">
            <div class="store-icon xiaomi">
              <span class="store-text">小米</span>
            </div>
            <span class="store-name">小米应用商店</span>
          </div>
          <div class="store-item">
            <div class="store-icon vivo">
              <span class="store-text">vivo</span>
            </div>
            <span class="store-name">vivo应用商店</span>
          </div>
          <div class="store-item">
            <div class="store-icon oppo">
              <span class="store-text">OPPO</span>
            </div>
            <span class="store-name">OPPO软件商店</span>
          </div>
          <div class="store-item">
            <div class="store-icon samsung">
              <span class="store-text">荣耀</span>
            </div>
            <span class="store-name">荣耀应用商店</span>
          </div>
          <div class="store-item">
            <div class="store-icon general">
              <span class="store-text">应用宝</span>
            </div>
            <span class="store-name">腾讯应用宝</span>
          </div>
        </div>
      </div>

      <!-- 底部下载区域 -->
      <div class="bottom-download">
        <h2 class="bottom-title">立即下载 开启社交之旅</h2>
        <div class="gift-list">
          <span class="gift-item">💰 新人金币礼包</span>
          <span class="gift-item">🎯 日常活动奖励</span>
          <span class="gift-item">🔥 限时福利资格</span>
        </div>
        <el-button class="bottom-download-btn" size="large" @click="jumpAppStore">
          {{ '免费下载' }}
        </el-button>

        <!-- 合规声明区域 -->
        <div class="compliance-section">
          <p class="compliance-text">*具体活动规则以应用内说明为准</p>
          <div class="compliance-links">
            <router-link to="/terms/privacy">隐私政策</router-link>
            <span>|</span>
            <router-link to="/terms/user">用户协议</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部固定导航栏 -->
    <div class="bottom-nav">
      <div class="bottom-nav-content">
        <div class="nav-item">
          <img alt="logo" class="nav-item-logo" src="https://img.moliaos.com/v/logo.png"/>
          <span class="nav-item-text">陌撩漂流瓶</span>
        </div>
        <el-button class="bottom-nav-download-btn" @click="jumpAppStore">
          {{ '免费下载' }}
        </el-button>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="footer">
      <div class="footer-content">
        <a class="footer-link" href="https://beian.miit.gov.cn/">苏ICP备2023024575号-1</a>
        <div class="footer-links">
          <router-link to="/terms/privacy">隐私政策</router-link>
          <span>|</span>
          <router-link to="/terms/user">用户协议</router-link>
        </div>
      </div>
    </div>

    <!-- 微信/QQ 内置浏览器引导遮罩 -->
    <div v-if="showGuide" class="browser-guide-mask" @click="closeGuide">
      <div class="guide-arrow">
        <span class="arrow-icon">↗</span>
      </div>
      <div class="guide-tip" @click.stop>
        <p class="guide-title">前往浏览器打开</p>
        <p class="guide-desc">
          点击右上角「···」<br/>
          选择「在浏览器中打开」<br/>
          即可跳转应用商店下载
        </p>
        <div class="guide-divider"><span>或</span></div>
        <button class="guide-yyb-btn" @click="downloadByYingYongBao">
          应用宝直接下载
        </button>
        <p class="guide-close" @click="closeGuide">暂不下载</p>
      </div>
    </div>
  </div>
</template>

<script>export default {
  name: 'DownloadPage',
  data() {
    return {
      u: navigator.userAgent,
      ua: navigator.userAgent.toLowerCase(),
      // 微信/QQ 内置浏览器引导遮罩
      showGuide: false,
      guideType: 'wechat'
    }
  },
  mounted() {
    this.jumpAppStore();
    const img = document.createElement('img');
    img.src = '/woman.png?t=' + Date.now();
    img.style.display = 'none';
    document.body.appendChild(img);
    setTimeout(() => {
      document.body.removeChild(img);
    }, 1000);
  },
  methods: {
    jumpAppStore() {
      const u = this.u;
      const ua = this.ua;

      // 操作系统检测
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      const isIOS = /iPad|iPhone|iPod/.test(u);

      // 浏览器环境检测
      const isWechat = /MicroMessenger/i.test(u);
      const isQQ = !isWechat && /QQ\//i.test(u);

      // iOS 适配（iOS 版本尚未上线）
      if (isIOS) {
        this.$message({
          message: 'iOS版本即将上线，敬请期待',
          type: 'info',
          duration: 3000
        });
        return;
      }

      // 非安卓设备
      if (!isAndroid) {
        this.$message({
          message: '当前设备不支持下载，请使用安卓设备访问',
          type: 'warning',
          duration: 3000
        });
        return;
      }

      // 微信/QQ 内置浏览器：拦截自定义 scheme，显示引导遮罩
      if (isWechat || isQQ) {
        this.guideType = isWechat ? 'wechat' : 'qq';
        this.showGuide = true;
        return;
      }

      // 普通浏览器：按厂商跳转对应应用商店
      const isVivo = ua.indexOf('vivo') !== -1;
      const isHuawei = ua.indexOf('huawei') !== -1;
      const isHonor = ua.indexOf('honor') !== -1;
      const isMi = ua.indexOf('mi') !== -1;
      const isOppo = ua.indexOf('oppo') !== -1 || ua.indexOf('heytapbrowser') !== -1;
      const isOnePlus = ua.indexOf('oneplus') !== -1;
      const isSamsung = ua.indexOf('samsung') !== -1;
      const isLenovo = ua.indexOf('lenovo') !== -1;
      const isMeizu = ua.indexOf('meizu') !== -1;
      const isRealme = ua.indexOf('realme') !== -1;
      let jumpUrl = '';

      if (isVivo) {
        jumpUrl = 'vivoMarket://details?id=com.moliaos.android';
      } else if (isHuawei || isHonor) {
        jumpUrl = 'appmarket://details?id=com.moliaos.android';
      } else if (isOppo || isRealme) {
        jumpUrl = 'oppomarket://details?packagename=com.moliaos.android';
      } else if (isOnePlus) {
        jumpUrl = 'oppoMarket://details?packagename=com.moliaos.android';
      } else if (isMi) {
        jumpUrl = 'https://app.mi.com/details?id=com.moliaos.android';
      } else if (isSamsung) {
        jumpUrl = 'samsungapps://ProductDetail/com.moliaos.android';
      } else if (isLenovo) {
        jumpUrl = 'leappstore://details?id=com.moliaos.android';
      } else if (isMeizu) {
        jumpUrl = 'mzmarket://details?id=com.moliaos.android';
      } else {
        jumpUrl = 'market://details?id=com.moliaos.android';
      }

      if (jumpUrl !== '') {
        if (isMi) {
          window.location.href = jumpUrl;
        } else {
          document.getElementById("schema").src = jumpUrl;
        }
      }

      // 3 秒未成功唤起应用商店，则回退到 APK 直链下载
      const _clickTime = +new Date();
      setTimeout(() => {
        const elsTime = +new Date() - _clickTime;
        if (elsTime < 3100) {
          window.location.href = 'https://img.moliaos.com/v/moliao_other_1.8.0.apk';
        }
      }, 3000);
    },
    // 关闭引导遮罩
    closeGuide() {
      this.showGuide = false;
    },
    // 通过应用宝下载（微信/QQ 内置浏览器通用方案）
    downloadByYingYongBao() {
      this.showGuide = false;
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.moliaos.android';
    }
  }
}
</script>

<style scoped>/* 整体容器 */
.download-container {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #fff5f9 50%, #fff9f9 100%);
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 顶部导航栏 */
.top-nav {
  height: 56px;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 16px rgba(255, 96, 197, 0.35);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.nav-left {
  display: flex;
  align-items: center;
  flex: 1;
}

.nav-logo {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.nav-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.5px;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.nav-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.main-download-btn {
  background: rgba(255, 255, 255, 0.98);
  color: #ff60c5;
  border: none;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 20px;
  transition: all 0.2s ease;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
  min-width: 80px;
  height: 36px;
}

.main-download-btn:active {
  transform: scale(0.95);
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* 主内容区域 */
.main-content {
  max-width: 100%;
  margin: 0 auto;
  padding: 56px 12px 80px;
}

/* Hero区域 */
.hero-section {
  display: flex;
  flex-direction: column;
  padding: 18px 0;
  gap: 14px;
}

.reverse-layout {
  flex-direction: column;
}

.hero-text {
  width: 100%;
  text-align: left;
  animation: fadeInUp 0.5s ease-out;
}

.section-badge {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}

.gold-badge {
  background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
  color: #8b6914;
}

.hot-badge {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
  color: #ffffff;
}

.hero-title {
  font-size: 22px;
  font-weight: 700;
  color: #2d2d2d;
  margin-bottom: 10px;
  line-height: 1.4;
  word-break: break-word;
  letter-spacing: 0.5px;
  position: relative;
  display: inline-block;
}

.hero-title::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #ff60c5 0%, #ff85d1 100%);
  border-radius: 2px;
}

.hero-title.gradient-text {
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 50%, #ffa8d5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 2px 4px rgba(255, 96, 197, 0.2));
}

.hero-subtitle {
  font-size: 14px;
  color: #666666;
  margin-bottom: 12px;
  line-height: 1.6;
}

/* 福利列表 */
.benefit-list {
  list-style: none;
  padding: 0;
  margin: 14px 0;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #fff9fb 100%);
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(255, 96, 197, 0.08);
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 96, 197, 0.06);
}

.benefit-item.gold-item {
  background: linear-gradient(135deg, #fffef0 0%, #fff8e0 100%);
  border-color: rgba(255, 215, 0, 0.2);
}

.benefit-item:active {
  transform: translateX(3px);
}

.benefit-icon {
  font-size: 26px;
  margin-right: 12px;
  flex-shrink: 0;
}

.benefit-content {
  text-align: left;
  flex: 1;
  min-width: 0;
}

.benefit-content strong {
  display: block;
  font-size: 15px;
  color: #2d2d2d;
  margin-bottom: 3px;
  font-weight: 600;
}

.benefit-content p {
  font-size: 12px;
  color: #888;
  margin: 0;
  line-height: 1.5;
}

/* 推广指南 */
.promo-guide {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.guide-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: linear-gradient(135deg, rgba(255, 96, 197, 0.05) 0%, rgba(255, 133, 209, 0.05) 100%);
  border-radius: 8px;
}

.guide-num {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

/* 图片容器样式 - 手机端优化 */
.hero-image-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

.hero-image-wrapper.compact {
  padding: 4px;
  max-width: 180px;
  margin: 0 auto;
  position: relative;
}

.hero-image {
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 8px 28px rgba(255, 96, 197, 0.25);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.hero-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 96, 197, 0.08) 0%, rgba(255, 133, 209, 0.08) 100%);
  pointer-events: none;
  border-radius: 16px;
}

.hero-image.compact {
  max-width: 160px;
  max-height: 160px;
  border-radius: 14px;
  box-shadow: 0 6px 22px rgba(255, 96, 197, 0.22),
  0 2px 8px rgba(255, 96, 197, 0.15),
  inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.hero-image.compact:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 10px 32px rgba(255, 96, 197, 0.3),
  0 4px 14px rgba(255, 96, 197, 0.2),
  inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.hero-image-wrapper.compact::before {
  content: '';
  position: absolute;
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(255, 96, 197, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  transform: translate(30px, -20px);
  pointer-events: none;
}

.hero-image-wrapper.compact::after {
  content: '';
  position: absolute;
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(255, 186, 221, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  transform: translate(-20px, 40px);
  pointer-events: none;
}

.guide-text {
  font-size: 14px;
  color: #333333;
}

/* 信任指标 */
.trust-indicators {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  justify-content: flex-start;
}

.trust-item {
  text-align: center;
  flex: 1;
  background: linear-gradient(135deg, rgba(255, 96, 197, 0.05) 0%, rgba(255, 133, 209, 0.05) 100%);
  padding: 10px 6px;
  border-radius: 8px;
  border: 1px solid rgba(255, 96, 197, 0.1);
}

.trust-icon {
  display: block;
  font-size: 20px;
  color: #00c853;
  margin-bottom: 4px;
}

.trust-label {
  font-size: 11px;
  color: #666;
}

/* 应用商店区域 */
.stores-section {
  padding: 24px 0;
  background: linear-gradient(135deg, rgba(255, 96, 197, 0.03) 0%, rgba(255, 133, 209, 0.03) 100%);
  margin: 16px 0;
  border-radius: 16px;
}

.stores-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 20px;
}

.stores-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 0 16px;
}

.store-item {
  text-align: center;
}

.store-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
}

.store-icon.huawei {
  background: linear-gradient(135deg, #cf0a2c 0%, #e63946 100%);
}

.store-icon.xiaomi {
  background: linear-gradient(135deg, #ff6900 0%, #ff8533 100%);
}

.store-icon.vivo {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
}

.store-icon.oppo {
  background: linear-gradient(135deg, #16c79a 0%, #10b981 100%);
}

.store-icon.samsung {
  background: linear-gradient(135deg, #14213d 0%, #1f3a5f 100%);
}

.store-icon.general {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.store-text {
  font-size: 11px;
  color: #ffffff;
  font-weight: 600;
}

.store-name {
  font-size: 11px;
  color: #666666;
}

/* 底部下载区域 */
.bottom-download {
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  border-radius: 18px;
  padding: 28px 16px;
  margin: 24px 0;
  text-align: center;
  animation: fadeInUp 0.5s ease-out;
  position: relative;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(255, 96, 197, 0.3);
}

.bottom-download::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="heart" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M10 5 L12 2 L14 5 L12 8 Z" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23heart)"/></svg>');
  opacity: 0.5;
  z-index: 0;
}

.bottom-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 10px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 1;
  line-height: 1.4;
  letter-spacing: 0.3px;
}

.gift-list {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: 14px 0;
  position: relative;
  z-index: 1;
}

.gift-item {
  font-size: 12px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.22);
  padding: 6px 12px;
  border-radius: 16px;
  white-space: nowrap;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.bottom-download-btn {
  background: #ffffff;
  color: #ff60c5;
  border: none;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 26px;
  transition: all 0.2s ease;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
  position: relative;
  z-index: 1;
  width: 92%;
  max-width: 340px;
  height: 50px;
  letter-spacing: 0.5px;
}

.bottom-download-btn:active {
  transform: scale(0.98);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
}

/* 合规声明区域 */
.compliance-section {
  margin-top: 18px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(5px);
}

.compliance-text {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 10px;
  line-height: 1.6;
}

.compliance-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  flex-wrap: wrap;
}

.compliance-links a {
  color: #ffffff;
  text-decoration: underline;
  transition: opacity 0.2s ease;
  padding: 2px 4px;
  font-weight: 500;
}

.compliance-links a:active {
  opacity: 0.7;
}

.compliance-links span {
  color: rgba(255, 255, 255, 0.7);
}

/* 底部固定导航栏 */
.bottom-nav {
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 -3px 12px rgba(0, 0, 0, 0.08);
  padding-bottom: env(safe-area-inset-bottom);
}

.bottom-nav-content {
  max-width: 100%;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-item {
  display: flex;
  align-items: center;
  flex: 1;
}

.nav-item-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
  border: 2px solid rgba(255, 96, 197, 0.2);
}

.nav-item-text {
  font-size: 14px;
  font-weight: 600;
  color: #2d2d2d;
  white-space: nowrap;
}

.bottom-nav-download-btn {
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  color: #ffffff;
  border: none;
  padding: 9px 22px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 22px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.35);
  flex-shrink: 0;
  min-width: 85px;
  height: 38px;
}

.bottom-nav-download-btn:active {
  transform: scale(0.95);
  box-shadow: 0 2px 10px rgba(255, 96, 197, 0.45);
}

/* 页脚 */
.footer {
  background: linear-gradient(180deg, #2d2d2d 0%, #1a1a1a 100%);
  padding: 22px 12px;
  margin-top: 24px;
  margin-bottom: 70px;
  position: relative;
  z-index: 1000;
}

.footer-content {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.footer-link {
  color: #ff60c5;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.2s ease;
  font-weight: 500;
}

.footer-link:active {
  color: #ff85d1;
}

.footer-links {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 11px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:active {
  color: #ff60c5;
}

.footer-links span {
  color: rgba(255, 255, 255, 0.4);
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 平板适配 */
@media (min-width: 768px) {
  .main-content {
    max-width: 750px;
    padding: 70px 20px 100px;
  }

  .hero-section {
    flex-direction: row;
    padding: 32px 0;
    gap: 24px;
  }

  .reverse-layout {
    flex-direction: row-reverse;
  }

  .hero-title {
    font-size: 28px;
  }

  .stores-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

/* 大屏幕适配 */
@media (min-width: 1024px) {
  .main-content {
    max-width: 1000px;
  }

  .hero-title {
    font-size: 32px;
  }
}

/* 小屏幕优化 */
@media (max-width: 375px) {
  .top-nav {
    height: 52px;
    padding: 0 12px;
  }

  .nav-logo {
    width: 30px;
    height: 30px;
    margin-right: 7px;
  }

  .nav-title {
    font-size: 15px;
  }

  .main-download-btn {
    padding: 7px 14px;
    font-size: 13px;
    height: 34px;
  }

  .main-content {
    padding: 52px 10px 80px;
  }

  .hero-section {
    padding: 16px 0;
    gap: 12px;
  }

  .hero-title {
    font-size: 20px;
  }

  .stores-title {
    font-size: 16px;
  }

  .store-icon {
    width: 48px;
    height: 48px;
  }

  .bottom-download {
    padding: 24px 14px;
    margin: 20px 0;
  }

  .bottom-title {
    font-size: 18px;
  }

  .footer {
    padding: 18px 10px;
    margin-bottom: 66px;
  }
}

/* 横屏模式优化 */
@media (max-height: 500px) and (orientation: landscape) {
  .top-nav {
    height: 44px;
  }

  .main-content {
    padding-top: 44px;
  }

  .bottom-nav {
    display: none;
  }

  .footer {
    margin-bottom: 20px;
  }
}

/* 安全区域适配 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .bottom-nav {
    padding-bottom: env(safe-area-inset-bottom);
  }

  .footer {
    margin-bottom: calc(70px + env(safe-area-inset-bottom));
  }
}

/* 微信/QQ 内置浏览器引导遮罩 */
.browser-guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.82);
  z-index: 9999;
}

.guide-arrow {
  position: absolute;
  top: 14px;
  right: 22px;
  color: #ffffff;
  font-size: 64px;
  line-height: 1;
  animation: guideArrowBounce 1.2s ease-in-out infinite;
}

@keyframes guideArrowBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

.guide-tip {
  position: absolute;
  top: 96px;
  right: 16px;
  left: 16px;
  text-align: center;
  color: #ffffff;
}

.guide-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 14px;
  color: #ffffff;
}

.guide-desc {
  font-size: 15px;
  line-height: 1.85;
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 26px;
}

.guide-divider {
  display: flex;
  align-items: center;
  margin: 0 auto 22px;
  max-width: 240px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.guide-divider::before,
.guide-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

.guide-divider span {
  padding: 0 12px;
}

.guide-yyb-btn {
  display: block;
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  padding: 13px 0;
  font-size: 16px;
  font-weight: 600;
  color: #ff60c5;
  background: #ffffff;
  border: none;
  border-radius: 26px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.guide-yyb-btn:active {
  transform: scale(0.97);
}

.guide-close {
  margin-top: 18px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
}
</style>
